import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class PesoMaximoBalanzaBruto {
  static incrementarPesoMaximo () {
    const axios = getAxiosInstance()
    const promise = axios.post(`peso_maximo_balanza_bruto_seis_ejes`,
      `{"valores": {"nombre": "MAXCEABR"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static decrementarPesoMaximo () {
    const axios = getAxiosInstance()
    const promise = axios.delete(`peso_maximo_balanza_bruto_seis_ejes`,
      `{"clave": {"nombre": "MAXCEABR"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }
}

export default PesoMaximoBalanzaBruto
